import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  constructor(
    private authService: AuthService,
    private router: Router,
    private toastr: ToastrService,
    private spinner:NgxSpinnerService
  ) { }
  showError(err: any = {}) {
    this.spinner.hide();
    console.log(err);
    if (err.status == 401) {
      return this.toastr.error(err?.error?.message ?? "Unauthorized Action")
    } 
    else if (err.status == 403) {
      this.authService.coachLogout();      
        return this.toastr.error(err?.error?.message ?? "Failed to authenticate")
    }
    else if (err.status == 404) {
        return this.toastr.error(err?.error?.message ?? "Not found exception occured")
    }
    else if (err.status == 406) {
      this.router.navigate(["/settings"], {
        queryParams: { tab: "subscription" }
      });
        return this.toastr.error(err?.error?.message ?? "Subscription Expired")
    }
  else {
        return this.toastr.error("Internal server error occured. Please try again later")
    }
  }
}
